// extracted by mini-css-extract-plugin
export default {"google-button__content":"googleButton_google-button__content__3ZYvb","google-button__paragraph":"googleButton_google-button__paragraph__oYXtN"};